import React from 'react'
import Checkbox from '../../common/checkbox'

const RecordsTableRow = ({
    columns = [],
    selected,
    onToggle = () => {},
    disabled
}) => {

    const renderColumn = (column, index) => {
        return (
            <td key={index}>{column}</td>
        )
    }

    return (
        <tr style={{ backgroundColor: !selected || disabled ? 'rgb( 236, 236, 236) ' : undefined }}>
            <td>
                <Checkbox disabled={disabled} checked={selected} onChange={selected => onToggle(selected)} />
            </td>
            {columns.map(renderColumn)}
        </tr>
    )
}

export default RecordsTableRow
